class DataCardsFeedClick {
	constructor() {
		this.init();
	}

	init() {
        $(document).on("click", ".card-feed-item.selected .card-item__header,.card-feed-item.selected .card-item__content", function(e){
            const location = $(this).parents(".card-feed-item").find(".main-link:first").attr("href");
            window.location.href = location;
        });
	}
}

export default DataCardsFeedClick;